const doc = [({"ko":({"adminConstantHotelWaitingListStatus":({"notified":"통지됨", "waiting":"공실 대기"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;